import React, { useState } from 'react'
import { Box, Button, Card, CardActions, CardContent, SxProps, TextField, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { getSnapshot } from 'mobx-state-tree'
import Grid from '@mui/material/Unstable_Grid2'

import { useStore } from '../../hooks/useStore'
import { State } from '../../store/donateStore'

function PickStockCard () {
  const store = useStore()
  const snap = getSnapshot(store.Donate)
  const state = snap.state
  const symbol = snap.symbol

  if(state === 'personalize' as State) 
    return null
 
  return (
    <Card sx={sx.card}>
      <div style={{ height: 100 }}></div>
      <CardContent>
        <Grid container spacing={1}>
          <Grid xs={4}>
            <Typography>TODO retrieve name</Typography>
          </Grid>
          <Grid xs={8}>
            <Typography>{symbol}</Typography>
          </Grid>
        </Grid>
      </CardContent>

      <Box display="flex" justifyContent='flex-end'>
        <Button size='small' onClick={()=> store.Donate.setState('stock')}>Edit</Button> 
      </Box>
    </Card>
  )
}

export default observer(PickStockCard)

const sx = {
  card: {
    backgroundColor: 'white',
    width: 400,
    marginY: 1
  } as SxProps,
  nameUsername: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  } as SxProps,
}
